import { createSlice } from "@reduxjs/toolkit";
import { fetchGroups, fetchAllGroups } from "./groupThunks";

const initialState = {
    groups: [],
    allGroups: [],   // Full unpaginated list for AddTaskModal dropdown
    totalRows: 0,
    pagination: null,
    loading: false,
    error: null,
};

const groupSlice = createSlice({
    name: "groups",
    initialState,
    reducers: {
        setGroups: (state, action) => {
            state.groups = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGroups.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGroups.fulfilled, (state, action) => {
                state.loading = false;
                state.groups = action.payload.items;
                state.totalRows = action.payload.pagination?.totalItems || action.payload.items.length;
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchGroups.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch groups";
            })
            .addCase(fetchAllGroups.fulfilled, (state, action) => {
                state.allGroups = action.payload;
            })
            .addCase(fetchAllGroups.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch all groups";
            });
    },
});

export const { setGroups } = groupSlice.actions;
export default groupSlice.reducer;
